import { Body16Medium } from "@/components/typography/Body16Medium";
import { Body16Underline } from "@/components/typography/Body16Underline";
import { UserDto } from "@/types/dto/user-dto";
import { Table } from "flowbite-react";
import { useNavigate } from "react-router-dom";
import { CustomCell } from "../CustomCell";

interface Props {
  user: UserDto;
}

export const Row: React.FC<Props> = ({ user }) => {
  const navigate = useNavigate();
  const onClickName = () => {
    navigate("/profile/my-profile");
  };

  return (
    <Table.Row
      key={user.id}
      className="bg-white dark:border-gray-700 dark:bg-gray-800"
    >
      {/* <Table.Cell className="whitespace-nowrap font-medium text-gray-900 dark:text-white">
        {startIndex - index}
      </Table.Cell> */}
      <Table.Cell className="border" onClick={onClickName}>
        <CustomCell>
          <Body16Underline>{user.name}</Body16Underline>
        </CustomCell>
      </Table.Cell>
      <Table.Cell className="border">
        <CustomCell>
          <Body16Medium>{`${user.department?.name || ""}`}</Body16Medium>
        </CustomCell>
      </Table.Cell>
      <Table.Cell className="border">
        <CustomCell>
          <Body16Medium>{`${user.phone}`}</Body16Medium>
        </CustomCell>
      </Table.Cell>
      <Table.Cell className="border">
        <CustomCell>
          <Body16Medium>{`${user.email}`}</Body16Medium>
        </CustomCell>
      </Table.Cell>
    </Table.Row>
  );
};
